import { reduce, values } from "lodash";

const dateLookupFormatter = (result) => {
  let data =(result && result.data) || []
  if (data.length > 0) {
    data = reduce(data, (memo, item) => [...memo, ...values(item)], []);
  }
  return {
    data
  }
};

export default dateLookupFormatter;
